var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.isLoading !== 0 && _vm.isLoading !== false)?_c('div',{class:[
    'waiting-wrap',
    {
      'waiting-wrap__center' : _vm.center,
      'waiting-wrap__transparent' : _vm.transparent
    }
  ]},[(_vm.isLoading !== -1)?_c('div',{staticClass:"waiting",class:_vm.transparent && 'waiting__transparent'},[_c('div',{staticClass:"loading"},[_c('div',{staticClass:"loader"},_vm._l((3),function(i){return _c('span',{key:i,class:_vm.transparent && 'alternative'})}),0)])]):_vm._e(),(_vm.isLoading === -1)?_c('div',{staticClass:"loading-fail"},[_c('p',{staticClass:"fail-text"},[_vm._v(" Data failed loading. Please reload. ")]),_c('div',{staticClass:"fail-btn",on:{"click":_vm.fail}},[_vm._v(" Reload ")])]):_vm._e()]):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }